import axios from "axios"
import { baseUrlApi } from "./Api.js"
import Csrf from "./Csrf.js"

export default {

  getForms(params) {
    console.log('params getForm',params)
    const url = `${baseUrlApi}/forms`;
    const form = axios.get(url, { params });
    console.log('get params getForm',form);
    return form;
  },

  getFormPdf(params) {
    const url = `${baseUrlApi}/get-pdf`;
    return axios.get(url, {
      params,
      responseType: "arraybuffer",
      headers: {
        Accept: "application/pdf",
      },
    });
  },

  postCreateFormPublic(form) {
    const url = `${baseUrlApi}/forms-public/store`;
    return axios.post(url, form);
  },

  getCompaniesPublicFrom() {
    const url = `${baseUrlApi}/get-companies-public-from`;
    return axios.get(url);
  },
};

